import './_jquery';
import MobileDetect from 'mobile-detect';

jQuery(function() {
  let addPropertiesToClick, md;

  md = new MobileDetect(window.navigator.userAgent);

  // RIGHT SIDE CTA HOMEPAGE -- START
  if (window.location.pathname === '/') {
    addPropertiesToClick = function(className) {
      return $('.' + className).on('click', function() {
        if (!$('.right-side-cta').hasClass('right-side-cta-click-properties')) {
          return $('.right-side-cta').addClass('right-side-cta-click-properties');
        }
      });
    };
    if (["UnknownPhone", "UnknownTablet", "UnknownMobile", null].includes(md.mobile())) {
      $('.right-side-cta').hover(function() {
        return $(this).toggleClass('right-side-cta-hover-properties');
      });
    }
    addPropertiesToClick('right-side-cta__icon');
    addPropertiesToClick('right-side-cta__container__button');
    $('.hamburger--rev.is-active').on('click', function() {
      $('.right-side-cta').removeClass('right-side-cta-click-properties');
    });
  }
  // RIGHT SIDE CTA HOMEPAGE -- END

  // ICON HOVER COLOR
  $("[data-hover-color]").each(function() {
    let color;
    color = $(this).data('hover-color');

    $(this).on('mouseover', function() {
      $(this).css('background-color', color);
    });

    $(this).on('mouseout', function() {
      $(this).css('background-color', 'white');
    });
  });
});
